class DomService {
  getClosestScrollableParent (element) {
    if (!element || element === document) {
      return
    }

    if (window.getComputedStyle(element).overflowY === 'auto') {
      return element
    } else {
      return this.getClosestScrollableParent(element.parentNode)
    }
  }
}

export const domService = new DomService()
